<template>
  <div class="container_brand">
    <HomeHead></HomeHead>
    <div class="banner">
      <el-image
        alt="企业投票云服务-专为投票场景打造，支持职称评定投票、项目评优、奖励申报、评先进、股东大会、党代表选举、政协会议表决、人事任免、干部考核、优秀员工评选"
        style="width: 100%; height: 100%"
        :src="require('../../assets/images/brand/banner.jpg')"
        fit="fill"
      ></el-image>
      <el-button type="primary" class="apply" round @click="applyAccount()">
        免费试用
      </el-button>
    </div>
    <div class="context_box scene_box">
      <div class="ContentTitle">
        <span class="CTitle">场景介绍</span>
        <span class="CLine"></span>
      </div>
      <div class="context_body_box context_body_well">
        <div class="well_item_box" :style="wellItemStyle">
          <div class="well_item_before well_item_before_Scene"></div>
          <div class="well_item_after">
            <div class="well_item_after_size">
              <p>评选先进：</p>
              <p>投票方式：入围</p>
              <p>最低通过率：1/2</p>
              <p>最大通过数：80%</p>
              <p>奖项等级：国家级、省部级、集团公司级</p>
            </div>
          </div>
        </div>
        <div class="well_item_box" :style="wellItemStyle">
          <div class="well_item_before well_item_before_Scene1"></div>
          <div class="well_item_after">
            <div class="well_item_after_size">
              <p>职称评定：</p>
              <p>投票方式：入围</p>
              <p>最低通过率：2/3</p>
              <p>最大通过数：80%</p>
              <p>奖项等级：教高级工程师、高级工程师、中级工程师</p>
            </div>
          </div>
        </div>
        <div class="well_item_box" :style="wellItemStyle">
          <div class="well_item_before well_item_before_Scene2"></div>
          <div class="well_item_after">
            <div class="well_item_after_size">
              <p>项目评优：</p>
              <p>投票方式：打分、排序</p>
              <p>第一轮：打分</p>
              <p>第二轮：排序</p>
              <p>奖项等级：一等奖、二等奖、三等奖</p>
            </div>
          </div>
        </div>
        <div class="well_item_box" :style="wellItemStyle">
          <div class="well_item_before well_item_before_Scene3"></div>
          <div class="well_item_after">
            <div class="well_item_after_size">
              <p>代表选举：</p>
              <p>投票方式：入围</p>
              <p>最低通过率：1/2</p>
              <p>投票轮次：2次</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="context_box">
      <div class="ContentTitle">
        <span class="CTitle">灵活性</span>
        <span class="CLine"></span>
      </div>
      <div class="context_body">
        <el-image
          alt="企业投票云服务-专为投票场景打造，支持职称评定投票、项目评优、奖励申报、评先进、股东大会、党代表选举、政协会议表决、人事任免、干部考核、优秀员工评选"
          :src="require('../../assets/images/brand/003_04.jpg')"
          fit="fill"
        ></el-image>
      </div>
    </div>
    <div class="context_box">
      <div class="ContentTitle">
        <span class="CTitle">立即扫码</span>
        <span class="CLine"></span>
      </div>
      <div class="context_body">
        <el-image
          alt="企业投票云服务-专为投票场景打造，支持职称评定投票、项目评优、奖励申报、评先进、股东大会、党代表选举、政协会议表决、人事任免、干部考核、优秀员工评选"
          :src="require('../../assets/images/brand/003_06.jpg')"
          fit="fill"
        ></el-image>
        <div class="example_wxcode">
          <el-image
            alt="企业投票云服务-专为投票场景打造，支持职称评定投票、项目评优、奖励申报、评先进、股东大会、党代表选举、政协会议表决、人事任免、干部考核、优秀员工评选"
            :src="require('../../assets/images/brand/vote_example_wxcode.jpg')"
            :preview-src-list="wxCodeList"
          >
          </el-image>
          <span> 微信扫码体验 </span>
        </div>
      </div>
    </div>
    <div class="context_box">
      <div class="ContentTitle">
        <span class="CTitle">成功案例</span>
        <span class="CLine"></span>
      </div>
      <div class="context_body">
        <el-image
          alt="企业投票云服务-专为投票场景打造，支持职称评定投票、项目评优、奖励申报、评先进、股东大会、党代表选举、政协会议表决、人事任免、干部考核、优秀员工评选"
          :src="require('../../assets/images/brand/003_08.jpg')"
          fit="fill"
        ></el-image>
      </div>
    </div>
    <HomeFooter></HomeFooter>
  </div>
</template>
<script>
import HomeHead from '@/components/HomeHead.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  components: {
    HomeHead,
    HomeFooter
  },
  data () {
    return {
      boxStyle: {
        height: window.innerHeight - 106 + 'px',
        width: '100%'
      },
      imgStyle: {
        height: window.innerHeight - 106 - 120 + 'px',
        width: '100%'
      },
      wellIndex: -1,
      wellItemStyle: {
        height: (window.innerWidth * 0.25 * 1.92) + 'px',
        width: (window.innerWidth * 0.25) + 'px'
      },
      wxCodeList: [require('../../assets/images/brand/vote_example_wxcode.jpg')]
    }
  },
  methods: {
    applyAccount: function () {
      this.$router.push({ name: 'login', params: { loginType: 'signIn' }, query: { redirect: this.$route.path } })
    },
    wellMouseover: function (index) {
      this.wellIndex = index
    },
    wellMouseout: function (index) {
      this.wellIndex = -1
    }
  },
  mounted () {
    // this.$nextTick(() => {
    //   //   // console.log(window.getComputedStyle(this.$refs.wellImg).height)
    //   //   console.log(this.$refs.wellImg.offsetHeight)
    //   //   console.log(this.$refs.wellImg.style.height)
    //   //   this.wellItemStyle.height = this.$refs.wellImg.offsetHeight
    // })
  },
  created () {
    const _this = this
    if (_this.is_xs) {
      _this.wellItemStyle = {
        height: (window.innerWidth * 0.25 * 1.92) + 'px',
        width: (window.innerWidth * 0.25) + 'px'
      }
    } else {
      _this.wellItemStyle = {
        height: (window.innerWidth * 0.8 * 0.25 * 1.92) + 'px',
        width: (window.innerWidth * 0.8 * 0.25) + 'px'
      }
    }
  }
}
</script>
<style lang="less">
.banner {
  position: relative;
}
.apply {
  vertical-align: middle;
  position: absolute;
  left: 50%;
  top: 56%;
  margin-left: -50px;
  width: 100px;
}
.scene_box {
  background: url('../../assets/images/brand/sucess08.png') no-repeat;
  background-size: cover;
}
.context_box {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.context_body {
  flex-grow: 1;
  flex-shrink: 0;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;
  position: relative;
}
.example_wxcode {
  height: 180px;
  width: 130px;
  position: absolute;
  top: calc(50% - 90px);
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  color: #fff;
  opacity: 0.8;
}
.example_wxcode span {
  margin: 15px 0px;
}
.example_wxcode div {
  border-radius: 4px;
}
.ContentTitle {
  width: 220px;
  margin: 0 auto;
  height: 120px;
  flex-shrink: 0;
}
.ContentTitle .CTitle {
  width: 220px;
  text-align: center;
  display: block;
  font-size: 20px;
  font-weight: bold;
  margin: 60px auto 10px;
}
.ContentTitle .CLine {
  width: 220px;
  margin: 0 auto;
  height: 5px;
  background: url('../../assets/images/brand/002_03.png') no-repeat;
  display: block;
}
@media screen and (min-width: 768px) {
  .context_body_well {
    width: 80%;
  }
}
@media screen and (max-width: 768px) {
  .context_body_well {
    width: 100%;
  }
}
.well_item {
  background-color: #6b6b6a;
  width: 25%;
  color: #fff;
  font-size: 24px;
  position: relative;
}
.well_item_rotate {
  width: 100%;
  background-color: #6b6b6a;
  color: #fff;
  font-size: 20px;
  //position: absolute;
}
.well_item .el-image {
  display: block;
}
.well_item p {
  padding: 0px 25px;
}
// .well_item_before {
//   transform: rotateY(180deg);
//   transition: 3s;
// }
// .well_item_after {
//   transform: rotateY(0deg);
//   transition: 3s;
// }
.el-image__inner--center {
  top: 0px;
  left: 0px;
  transform: none;
}
.context_body_box {
  flex-grow: 1;
  flex-shrink: 0;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;
}
.well_item_box {
  background-color: #6b6b6a;
  //width: 25%;
  color: #fff;
  position: relative;
  box-sizing: border-box;
}

.well_item_before {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-position: center center;
  //backface-visibility: hidden;
  transition: 1.5s;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
}
.well_item_before_Scene {
  background-image: url('../../assets/images/brand/Scene.jpg');
}
.well_item_before_Scene1 {
  background-image: url('../../assets/images/brand/Scene1.jpg');
}
.well_item_before_Scene2 {
  background-image: url('../../assets/images/brand/Scene2.jpg');
}
.well_item_before_Scene3 {
  background-image: url('../../assets/images/brand/Scene3.jpg');
}

.well_item_after {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  background-color: #6b6b6a;
  //   text-indent: 1.8em;
  transform: rotateY(-180deg);
  backface-visibility: hidden;
  transition: 1.5s;
}
.well_item_box:hover .well_item_before {
  transform: rotateY(180deg);
}
.well_item_box:hover .well_item_after {
  transform: rotateY(0deg);
}

@media screen and (min-width: 768px) {
  .well_item_after_size {
    font-size: 20px;
    padding: 0px 15px;
  }
}
@media screen and (max-width: 768px) {
  .well_item_after_size {
    font-size: 8px;
    padding: 0px 0px;
  }
}
</style>
